import $ from 'jquery';
// See: https://github.com/ademilter/bricklayer/issues/13
import Bricklayer from 'bricklayer';
import { directiveSettings } from '../../utils/parse';

export default function masonryDirective(context=document.body) {
	const $context = $(context);
	const $masonries = $context.find('[sw-masonry]');

	$masonries.each(function() {
		const $element = $(this);
		const json = $element.attr('sw-masonry');
		const settings = directiveSettings(json, {
			rulerClassName: 'masonry_ruler',
			columnClassName: 'masonry_column',
		});

		var bricklayer = new Bricklayer(this, settings);

		$element.data('masonry', bricklayer);
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/masonry.js